import { RecordingInterface } from "../shared/RecordingInterface";
import { transcribeAudio } from "../../../lib/transcription";
import { useAuth } from "../../../contexts/AuthContext";
import { useToast } from "../../ui/use-toast";

interface RecordingSectionProps {
  setActiveSection: (section: string) => void;
}

export function RecordingSection({ setActiveSection }: RecordingSectionProps) {
  const { user } = useAuth();
  const { toast } = useToast();

  const handleComplete = async (blob: Blob, wasCancelled: boolean) => {
    if (!user || wasCancelled) {
      setActiveSection("default");
      return;
    }
    
    try {
      const transcription = await transcribeAudio(blob, user.id, 'meeting');
      console.log("Transcription:", transcription);
      toast({
        title: "Recording complete",
        description: "Your recording has been saved and is being transcribed.",
      });
      setActiveSection("default");
    } catch (error) {
      console.error("Transcription error:", error);
      toast({
        title: "Error",
        description: "Failed to process recording. Please try again.",
        variant: "destructive",
      });
    }
  };

  return (
    <div className="w-full p-4">
      <RecordingInterface
        onCancel={() => setActiveSection("default")}
        onComplete={handleComplete}
        title="Meeting Recording"
      />
    </div>
  );
}